module.exports = "@import url(\"https://fonts.googleapis.com/css?family=Roboto+Mono&display=swap\");\n"